import {PullRequestSidebarNudge, type PullRequestSidebarNudgeProps} from './PullRequestSidebarNudge'

export type PullRequestSidebarNudgePartialProps = PullRequestSidebarNudgeProps

export function PullRequestSidebarNudgePartial(props: PullRequestSidebarNudgePartialProps) {
  return <PullRequestSidebarNudge {...props} />
}
